(ns income.views
  (:require
    [reagent.core :as r]
    [reagent.format :as fmt]
    [very.re-frame.core :as rf :refer [>evt]]
    [main.common :as common]
    [profile.common :as pc]
    [util.core :refer [long-str string->float]]
    [css.form :as form]
    [css.core :refer [defstyled]]
    [util.core :refer [safe-merge]])
  (:require-macros
    [logging.core :refer [log]]))

(defn- default-income-values [values]
  (safe-merge {:salary 0
               :other-income 0
               :investment-income 0
               :social-security-income 0}
              values))

(defn- default-form-values [values]
  (merge {:client (default-income-values (:client values))}
         (when (:spouse values) {:spouse (default-income-values (:spouse values))})))

(defn income-form [values {:keys [on-save on-cancel cancel-label] :or {cancel-label "Cancel"}}]
  (let [form-page (r/atom 0)
        form-values (r/atom (default-form-values values))]
    (fn []
      (let [field (fn [path label]
                    [form/input-row-s {:currency? true}
                     [form/input-label-s label]
                     [form/input
                      {:type "number"
                       :max-width "100%"
                       :name (apply str (map name path))
                       :label? true
                       :unit? true
                       :default-value (get-in @form-values path)
                       :on-change #(swap! form-values assoc-in path (.. % -target -value))}]])]
        [common/form-page-s
         [common/form-s
          {:on-submit (fn [e]
                        (.preventDefault e)
                        ;; since we can be nested in :client/:spouse,
                        ;; update the nested values from strs to floats
                        (let [to-numeric (fn [vs]
                                           (reduce (fn [m [k v]]
                                                     (assoc m k
                                                            (if (not= :id k)
                                                              (string->float v)
                                                              v)))
                                                   {}
                                                   vs))
                              income (reduce
                                       (fn [m [k v]]
                                         (assoc m k (to-numeric v)))
                                       {}
                                       @form-values)]
                          (on-save income)))
           :max-width "830px"}
          [common/form-header-s
           [common/form-title-s {:margin "45px 0 0"} "Income"]
           [common/form-explain-s "Your annual income plays a big part in shaping your personal financial plan. Having an idea of how much money you make and where it comes from will help us optimize your game plan to reach your goals."]]

          [pc/form-section-s
           [pc/form-section-header-s
            [pc/form-section-title-s "Total household income"]
            [pc/form-section-total-s "Total: " (fmt/currency-format (:total-income values))]]
           [pc/form-section-description-s "Household income is calculated by adding up all of your annual income. If you do not receive income from one of the following sources, or if you're not sure of the total amount, you can leave that section blank."]

           [pc/column-wrapper-s
            [pc/form-column-s
             [pc/column-title-s "My income sources"]
             [field [:client :salary] "Annual salary + bonus"]
             [field [:client :investment-income] "Annual income from investments"]
             [field [:client :social-security-income] "Annual social security income"]
             [field [:client :other-income] "Other"]]

            (when (and (:spouse values)
                       (not (get-in values [:spouse :retired])))
              [pc/form-column-s
               [pc/column-title-s "My partner's sources"]
               [field [:spouse :salary] "Annual salary + bonus"]
               [field [:spouse :investment-income] "Annual income from investments"]
               [field [:spouse :social-security-income] "Annual social security income"]
               [field [:spouse :other-income] "Other"]])]

           [form/button-row-s
            [form/secondary-button-s {:type "button"
                                      :on-click on-cancel} cancel-label]
            [form/button {:type "submit"} "Save"]]]]]))))

(defn income [income {:keys [on-edit]}]
  [:section
   [common/profile-section-header {:link on-edit
                                   :text "Edit"
                                   :title "Income"}]
   (if (not= (:total-income income) 0)
     [common/data-row-full {:label "Total household income:"
                            :value (fmt/currency-format (:total-income income))}]
     [common/no-results
      {:text (long-str "The money you make today creates a foundation for a meaningful tomorrow. "
                       "Enter your household income to start planning for a fulfilling future.")
       :button-text "Enter your income"
       :button-click on-edit}])])
